import classNames from 'classnames';
import type { FC, ReactNode } from 'react';
import type { CSSProperties } from 'styled-components';

import { getBackgroundColorStyle } from '../../utils/background';

import { DropdownProvider } from '@/navbarElement/DropdownProvider';
import type { NavbarMenuDropdownElementProps } from '../../navbarElement/Navbar.type';
import {
  NAVBAR_MENU_DROPDOWN_CARD_DEFAULTS,
  NAVBAR_MENU_DROPDOWN_FULL_DEFAULTS,
  NAVBAR_MENU_DROPDOWN_MOBILE_DEFAULTS,
} from '../../navbarElement/NavbarMenuDropdown.constants';
import * as styles from '../Navbar.css';
import type { NavbarMenuItemV2ElementProps } from '../navbarMenuItemElement';
import { NavbarMenuItemDropdown } from '../navbarMenuItemElement/components';

export function NavbarMenuDropdownV2(
  props: NavbarMenuDropdownElementProps & {
    controlbyselected: boolean | string;
    screen: 'desktop' | 'mobile';
    navbarItemElementProps?: NavbarMenuItemV2ElementProps & {
      controlbyselected: boolean | string;
      selected: boolean;
    };
  },
) {
  const {
    element,
    screen,
    className,
    children,
    controlbyselected: controlbyselectedProp,
    attributes,
    navbarItemElementProps,
  } = props;
  let controlbyselected = controlbyselectedProp;
  if (typeof controlbyselected === 'string') {
    controlbyselected = controlbyselected === 'true';
  }
  const { style, padding, background, border_radius, customAttributes } = element.attrs || {};

  const DEFAULTS = style === 'card' ? NAVBAR_MENU_DROPDOWN_CARD_DEFAULTS : NAVBAR_MENU_DROPDOWN_FULL_DEFAULTS;

  if (screen === 'mobile' && !element.attrs?.parentInMobile) {
    return (
      // biome-ignore lint/a11y/useValidAriaRole: <explanation>
      <div
        {...props}
        role="none"
        {...customAttributes}
        className={classNames(styles.navbarMobileDropdownV2, className, customAttributes?.className)}
        style={
          {
            '--padding': padding ?? NAVBAR_MENU_DROPDOWN_MOBILE_DEFAULTS.padding,
            '--gap': NAVBAR_MENU_DROPDOWN_MOBILE_DEFAULTS.gap,
            ...getBackgroundColorStyle(background ?? NAVBAR_MENU_DROPDOWN_MOBILE_DEFAULTS.background),
            // pointerEvents: open ? 'auto' : 'none',
          } as CSSProperties
        }
      >
        {children}
      </div>
    );
  }

  const Wrapper: FC<{ children: ReactNode }> = ({ children }) => {
    const shouldRenderWithNavbarMenuItemDropdown =
      attributes?.['data-should-render-with-navbar-menu-item-dropdown'] !== undefined;

    return shouldRenderWithNavbarMenuItemDropdown && navbarItemElementProps ? (
      <DropdownProvider>
        <NavbarMenuItemDropdown {...navbarItemElementProps}>
          {children}
          {/* Separator is inside the NavbarMenuItemDropdown component */}
        </NavbarMenuItemDropdown>
      </DropdownProvider>
    ) : (
      <>{children}</>
    );
  };

  return (
    <Wrapper>
      {/* biome-ignore lint/a11y/useValidAriaRole: <explanation> */}
      <div
        {...props}
        {...attributes}
        role="none"
        {...customAttributes}
        className={classNames(styles.navbarDropdownV2, className, customAttributes?.className)}
        onMouseEnter={
          controlbyselected
            ? () => {}
            : () => {
                // setDropdownSelected(true);
              }
        }
        onMouseLeave={
          controlbyselected
            ? () => {}
            : () => {
                // setDropdownSelected(false);
              }
        }
        style={
          {
            '--padding': padding ?? DEFAULTS.padding,
            '--border-radius': border_radius ?? DEFAULTS.borderRadius,
            '--width': DEFAULTS.width,
            ...getBackgroundColorStyle(background ?? DEFAULTS.background),
          } as CSSProperties
        }
      >
        {children}
      </div>
    </Wrapper>
  );
}
